import React, { useContext, useState } from "react";
import { Button, Input, ButtonGroup } from "reactstrap";
import { TbEdit } from "react-icons/tb";
import NoImage from "../images/no-image.png";
import { RxCross2 } from "react-icons/rx";
import { FaCheck } from "react-icons/fa6";
import { Tooltip } from "react-tooltip";

function UserList({ user, onUpdate, onViewProfile }) {
  const [update, setupdate] = useState(false);

  const [designation, setDesignation] = useState(
    user?.designation || ""
  );
  const [admin, setAdmin] = useState(
    user?.admin === 1 ? true : false
  );
  const [active, setActive] = useState(
    user?.isActive === 1 ? true : false
  );
  return (
    <tr key={user?._id}>
      <td
        width={"35%"}
        onClick={() => onViewProfile()}
        data-tooltip-id={user?._id}
        data-tooltip-content={`Please click to view all passwords for ${user?.name}. `}
        style={{ cursor: "pointer" }}
      >
        <img
          className="userImg memberIcon "
          src={user?.profilePhoto || NoImage}
          alt="user"
          referrerPolicy="no-referrer"
          style={{ height: 50, width: 50 }}
        />
        <div className="userName">
          {user?.name}
          <span>{user?.email}</span>
        </div>
        <Tooltip place="top" effect="float" id={user?._id} />
      </td>
      <td width={"30%"}>
        {update ? (
          <div className="formElmWrap">
            <Input
              id="designation"
              name="Designation"
              type="text"
              placeholder="Designation"
              value={designation}
              onChange={(e) => {
                setDesignation(e.target.value);
              }}
            />
          </div>
        ) : (
          <span className="userName">
            {user?.designation ? user?.designation : "NA"}
          </span>
        )}
      </td>
      <td>
        {update ? (
          <div className="formElmWrap">
            <Input
              id="admin"
              name="Admin"
              type="select"
              value={admin}
              onChange={(e) => {
                setAdmin(e.target.value);
              }}
            >
              <option value={true}>True</option>
              <option value={false}>False</option>
            </Input>
          </div>
        ) : (
          <span className="userName">
            {user?.admin ? (
              <FaCheck className="editBtn" color="green" />
            ) : (
              <RxCross2 color="red" className="editBtn" />
            )}
          </span>
        )}
      </td>
      <td>
        {update ? (
          <div className="formElmWrap">
            <Input
              id="exampleSelect"
              name="select"
              type="select"
              value={active}
              onChange={(e) => {
                setActive(e.target.value);
              }}
            >
              <option value={true}>True</option>
              <option value={false}>False</option>
            </Input>
          </div>
        ) : (
          <span className="userName">
            {user?.isActive ? (
              <FaCheck className="editBtn" color="green" />
            ) : (
              <RxCross2 color="red" className="editBtn" />
            )}
          </span>
        )}
      </td>
      <td className="btnTd">
        {update ? (
          <div style={{ display: "flex" }}>
            <Button
              color="primary"
              onClick={() => {
                onUpdate(
                  {
                    designation: designation,
                    admin: admin,
                    isActive: active,
                  },
                  user?._id
                );
                setupdate(false);
              }}
            >
              Update
            </Button>
            <Button
              className="editBtn"
              onClick={() => setupdate(false)}
            >
              <RxCross2 color="red" />
            </Button>
          </div>
        ) : (
          <Button className="editBtn" onClick={() => setupdate(true)}>
            <TbEdit />
          </Button>
        )}
      </td>
    </tr>
  );
}

export default UserList;
